// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Aoe7H","header":"ReportDetails_header__9b7LF","title":"ReportDetails_title__Ncyzs","left":"ReportDetails_left__3gFZp"};